import { APPROACH } from "@/lib/content";

export default function ProfessionalApproach() {
  return (
    <section id="approach" data-testid="approach-section" className="relative bg-offwhite py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-hairline" />
              <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">05 — Our Approach</span>
            </div>
            <h2 className="font-serif text-navy text-3xl md:text-4xl lg:text-5xl font-light leading-[1.1] tracking-[-0.01em] sticky top-32">
              Our <em className="text-gold not-italic">professional</em> approach.
            </h2>
          </div>

          <div className="lg:col-span-8">
            <ol className="grid sm:grid-cols-2 gap-px bg-softgray border border-softgray">
              {APPROACH.map((item, i) => (
                <li key={i} data-testid={`approach-item-${i}`} className="bg-white p-8 md:p-10">
                  <div className="font-serif text-gold text-sm font-medium italic mb-3">
                    0{i + 1}.
                  </div>
                  <div className="text-navy text-lg font-serif leading-snug">
                    {item}
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
